module.exports = __webpack_public_path__ + "img/settings7.eb82fd97.png";